import { Badge } from 'reactstrap';
import Link from 'next/link';

import React from 'react';

export default function LabelBadges({ value }) {
  if (!value) return <></>;
  return (
    <>
      {value.map(label => (
        <Link href={`/app/labels/${label.id}`} key={label.id}>
          <Badge pill key={label.id} color={label.color}>
            {label.name}
          </Badge>{' '}
        </Link>
      ))}
    </>
  );
}
